<template>
  <div>
    <h5>Listas de Controles - {{ nombreControl }}</h5>
    <b-row>
      <b-col sm="4">
        <b-form-group>
          <label for="buscar">Buscar</label>
          <b-form-input
            id="buscar"
            name="buscar"
            type="text"
            v-model="filtroListas.buscar"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="2">
        <b-form-group>
          <label for="estado">Estado</label>
          <el-select
            v-model="filtroListas.estado"
            multiple
            :rows="3"
            :max-rows="6"
            name="estado"
            id="estado"
          >
            <el-option
              v-for="estado in estados"
              :key="estado.value"
              :label="estado.text"
              :value="estado.value"
            >
            </el-option>
          </el-select>
        </b-form-group>
      </b-col>
      <b-col sm="6">
        <b-button
          v-b-modal.modal-2
          variant="primary"
          class="float-right mt-4"
          @click="creaLista"
        >
          <i class="fa fa-plus"></i>
          Crear
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="4" lg="4">
        <b-button-group size="md">
          <b-button
            variant="primary"
            @click.prevent="buscadorLista(filtroListas)"
          >
            <i class="fa fa-search fa-lg"></i>
            <span class="d-none d-md-inline-block ml-1">Buscar</span>
          </b-button>
          <b-button @click.prevent="limpiarLista()">
            <i class="fa fa-eraser fa-lg"></i>
            <span class="d-none d-md-inline-block ml-1"> Limpiar</span>
          </b-button>
        </b-button-group>
      </b-col>
    </b-row>
    <br />

    <b-table
      thead-tr-class="table-active"
      bordered
      responsive
      striped
      hover
      :items="listas.data"
      :fields="columnasListas"
      show-empty
      empty-text="No hay listas para mostrar"
    >
      <template v-slot:cell(activo)="data">
        <b-badge
          v-if="data.item.activo == '1'"
          variant="primary"
          v-text="'Activo'"
        />
        <b-badge v-else variant="danger" v-text="'Inactivo'" />
      </template>
      <template v-slot:cell(actions)="data">
        <a
          v-b-tooltip.hover
          title="Editar Lista"
          class="botonProduct mr-2"
          @click="verLista(data.item.id)"
        >
          <i class="fa fa-edit fa-lg"></i>
        </a>
        <a
          v-b-tooltip.hover
          class="botonProduct"
          :title="data.item.activo ? 'Inactivar' : 'Activar'"
          @click="activarInactivarLista(data.item)"
        >
          <i class="fa fa-close text-danger" v-if="data.item.activo" />
          <i class="fa fa-check text-success" v-else />
        </a>
      </template>
    </b-table>
    <el-pagination
      v-model="filtroListas.page"
      @size-change="setPerPagePaginationListas"
      @current-change="setPagePaginationListas"
      :current-page="filtroListas.page"
      :page-sizes="[10, 30, 50, 100]"
      :page-size="filtroListas.perPage"
      :total="listas.total"
      layout="total, sizes, prev, pager, next"
      class="float-right"
    >
    </el-pagination>
    <b-button
      @click="cambiarVistaListasControles"
      size="sm"
      variant="secondary"
      class="float-left"
    >
      <i class="fa fa-reply fa-lg"></i>
      Volver
    </b-button>
    <br />
    <br />
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  name: "formulario-listas",
  data() {
    return {
      estados: [
        {
          value: 0,
          text: "Inactivo",
        },
        {
          value: 1,
          text: "Activo",
        },
      ],
      columnasListas: [
        {
          key: "codigo",
          label: "Codigo",
          sortable: true,
          thStyle: { "max-width": "85px", width: "85px" },
        },
        {
          key: "control.control",
          label: "Control",
          sortable: true,
        },
        {
          key: "lista",
          label: "Lista",
          sortable: true,
        },
        {
          key: "activo",
          label: "Estado",
          sortable: true,
          thStyle: { "max-width": "85px", width: "85px" },
          tdClass: "text-center",
        },
        {
          key: "actions",
          label: "Opciones",
          thStyle: { "max-width": "95px", width: "95px" },
          tdClass: "text-center",
        },
      ],
    };
  },
  methods: {
    creaLista() {
      this.resetSelectedLista();
      this.$emit("vModalListas", true);
    },
    async cambiarVistaListasControles() {
      this.resetFiltroControles();
      this.setPageControles(1);
      await this.getControles();
      this.$emit("cambiarVistaListasControles", 1);
    },
    async buscadorLista(buscar) {
      this.setPageListas(1);
      this.setFiltroListas(buscar);
      await this.getListas();
    },
    async limpiarLista() {
      this.resetFiltroListas();
      await this.getListas();
    },
    async verLista(id) {
      await this.mostrarLista(id);
      this.$emit("vModalListas", true);
    },
    async activarInactivarLista(item) {
      item.activo = item.activo === 1 ? 0 : 1;
      this.setLista(item);
      await this.actualizarLista();
      await this.getListas();
    },
    ...mapActions("administracion", [
      "getListas",
      "mostrarLista",
      "actualizarLista",
      "getControles",
      "setPagePaginationListas",
      "setPerPagePaginationListas",
    ]),
    ...mapMutations("administracion", [
      "resetSelectedLista",
      "setPageListas",
      "setFiltroListas",
      "resetFiltroListas",
      "setLista",
      "setPageControles",
      "resetFiltroControles"
    ]),
  },
  computed: {
    ...mapState("administracion", [
      "selectedControl",
      "selectedLista",
      "filtroListas",
      "listas",
      "nombreControl",
      "selectedListas",
      "accionControl",
      "accionLista",
      "visualizarModalControles",
      "filtroControles",
    ]),
  },
};
</script>